import Users from '@/components/users/Users'
import UserList from '@/components/users/UserList'
import ManageUser from '@/components/users/ManageUser'

export default [
  {
    path: '/users',
    component: Users,
    children: [
      {path: '', component: UserList},
      {path: ':uid', component: ManageUser}
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/users/routes.js